import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "fixed inset-0 z-50 flex items-center justify-center p-4" };
const _hoisted_2 = { class: "relative w-full max-w-md bg-white rounded-xl shadow-2xl p-6 flex flex-col gap-5" };
const _hoisted_3 = { class: "flex items-center justify-between" };
const _hoisted_4 = { class: "flex items-center gap-3" };
const _hoisted_5 = { class: "text-base font-semibold text-gray-900" };
const _hoisted_6 = { class: "text-sm text-gray-600" };
const _hoisted_7 = { class: "text-gray-900" };
const _hoisted_8 = { class: "flex items-center justify-end gap-2.5" };
const _hoisted_9 = ["disabled"];
const _hoisted_10 = ["disabled"];
const _hoisted_11 = {
    key: 0,
    class: "w-4 h-4 animate-spin",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
};
export default /*@__PURE__*/ _defineComponent({
    __name: 'DeleteConfirmModal',
    props: {
        chargeName: {},
        isDeleting: { type: Boolean }
    },
    emits: ["confirm", "cancel"],
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", {
                        class: "absolute inset-0 bg-black/40",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('cancel')))
                    }),
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "flex items-center justify-center w-9 h-9 rounded-full bg-red-100" }, [
                                    _createElementVNode("svg", {
                                        class: "w-5 h-5 text-red-600",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        "stroke-width": "2",
                                        stroke: "currentColor"
                                    }, [
                                        _createElementVNode("path", {
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                            d: "m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                                        })
                                    ])
                                ], -1)),
                                _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t("services.charges.modals.delete_title")), 1)
                            ]),
                            _createElementVNode("button", {
                                type: "button",
                                class: "flex items-center justify-center w-7 h-7 text-gray-400 bg-gray-100 rounded-md hover:bg-gray-200 transition-colors",
                                onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('cancel')))
                            }, [...(_cache[5] || (_cache[5] = [
                                    _createElementVNode("svg", {
                                        class: "w-4 h-4",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        "stroke-width": "2",
                                        stroke: "currentColor"
                                    }, [
                                        _createElementVNode("path", {
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                            d: "M6 18 18 6M6 6l12 12"
                                        })
                                    ], -1)
                                ]))])
                        ]),
                        _createElementVNode("p", _hoisted_6, [
                            _createTextVNode(_toDisplayString(_ctx.$t("services.charges.modals.delete_lead")) + " ", 1),
                            _createElementVNode("strong", _hoisted_7, "\"" + _toDisplayString(__props.chargeName) + "\"", 1),
                            _createTextVNode("? " + _toDisplayString(_ctx.$t("services.charges.modals.delete_tail")), 1)
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors",
                                disabled: __props.isDeleting,
                                onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.$emit('cancel')))
                            }, _toDisplayString(_ctx.$t("services.charges.actions.cancel")), 9, _hoisted_9),
                            _createElementVNode("button", {
                                type: "button",
                                class: "flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50",
                                disabled: __props.isDeleting,
                                onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.$emit('confirm')))
                            }, [
                                (__props.isDeleting)
                                    ? (_openBlock(), _createElementBlock("svg", _hoisted_11, [...(_cache[6] || (_cache[6] = [
                                            _createElementVNode("circle", {
                                                class: "opacity-25",
                                                cx: "12",
                                                cy: "12",
                                                r: "10",
                                                stroke: "currentColor",
                                                "stroke-width": "4"
                                            }, null, -1),
                                            _createElementVNode("path", {
                                                class: "opacity-75",
                                                fill: "currentColor",
                                                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                            }, null, -1)
                                        ]))]))
                                    : _createCommentVNode("", true),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t("services.charges.actions.delete")), 1)
                            ], 8, _hoisted_10)
                        ])
                    ])
                ])
            ]));
        };
    }
});
